// extracted by mini-css-extract-plugin
export var statItem = "_i4-1";
export var statsRow = "_i4-0";